import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService, UrlParam } from "./classes/BaseService";
import { Observable } from 'rxjs';

@Injectable()
export class InfoService extends BaseService{

  apiUrl: string = "Info.php?";

  constructor(protected http: HttpClient) { 
    super(http);
  }

  getUserCountry() {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getUserCountry")
    );

    return this.get(url);
  }

  getUserLocation(): Observable<any> {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getUserLocation")
    );

    return this.get(url);
  }

  getUserDataBySessionToken(sessionToken: string, country: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getUserDataBySessionToken"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country)
    );

    return this.get(url);
  }

  getLastCardDealId(country: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getLastCardDealId"),
      new UrlParam("country", country)
    );

    return this.get(url);
  }

  set404Info(nonExistingUrl: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "set404Info"),
      new UrlParam("urlInfo", encodeURIComponent(nonExistingUrl))
    );

    return this.get(url);
  }

}
